module.exports = __webpack_public_path__ + "img/GAME_TRAIN1.88dcf02c.jpg";